import * as _4 from 'lodash4';
class ScheduledCourseTileCircleController {
  private course: any;
  private circleBackgroundColor: string;
}

class ScheduledCourseTileCircle implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      course: '=',
      circleBackgroundColor: '<'
    };
    this.controller = ScheduledCourseTileCircleController;
    this.templateUrl =
      'capability-ng-academic-planner/src/global/components/scheduled_course_tile_circle/scheduled_course_tile_circle.html';
  }
}

angular
  .module('capability-ng-academic-planner')
  .component('scheduledCourseTileCircle', new ScheduledCourseTileCircle());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/scheduled_course_tile_circle/scheduled_course_tile_circle.ts